import {Button} from 'primereact/button'
import {Card} from 'primereact/card'
import {Chart} from 'primereact/chart'
import {Column} from 'primereact/column'
import {DataTable} from 'primereact/datatable'
import {ProgressSpinner} from 'primereact/progressspinner'
import React, {useContext, useEffect, useState} from 'react'
import {ToastContext} from '../../../../App'
import {useMobile} from '../../../../hooks/useMobile'
import {
	useGetStationsStatisticQuery
} from '../../../../redux/services/statistic'
import {
	centerTextPlugin,
	drawCircles,
	formatDates,
	parseStationsData
} from '../../../../utils/charts'
import getSubdomain from '../../../../utils/getSubdomain'
import * as styles from './StationsStatistics.module.css'

const StationsStatistics = ({ selectedDates }) => {
	const showToast = useContext(ToastContext);
	
	const { data: stationsStatistic, isSuccess: isStationsStatisticSuccess, isError: isStationsStatisticError } =
		useGetStationsStatisticQuery({
			subDomain: getSubdomain(),
			dates: formatDates(selectedDates),
		});
	
	const [doughnutData, setDoughnutData] = useState({});
	const [doughnutOptions, setDoughnutOptions] = useState({});
	const [rawDoughnutData, setDoughnutRawData] = useState([])
	const [stationsTotalCost, setStationsTotalCost] = useState(0)
	const [stationsAvgCost, setStationsAvgCost] = useState(0)
	
	useEffect(() => {
		if(isStationsStatisticError)
			showToast("error", "Statistic", "Unable to load station statistics")
	}, [isStationsStatisticError])
	
	useEffect(() => {
		if(isStationsStatisticSuccess) {
			const {
				data,
				options,
				parsedData,
				avgCost,
				totalCost
			} = parseStationsData(stationsStatistic)
			
			setDoughnutRawData(parsedData);
			setStationsTotalCost(totalCost)
			setStationsAvgCost(avgCost)
			setDoughnutData(data);
			setDoughnutOptions(options);
		}
	}, [isStationsStatisticSuccess, stationsStatistic]);
	
	const formatCurrency = (value) => {
		return Number.parseFloat(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
	};
	
	return (
		<>
			<div className={styles.chartsBlock} >
				<h3>Overview</h3>
				<div className={`${styles.cardWrapper}`}>
					<Card title="Total Orders" className={styles.chartCard}>
						<div className={styles.totalOrdersCardContent}>
							{isStationsStatisticSuccess ? (
								<>
									<Chart type="doughnut" data={doughnutData} options={doughnutOptions} plugins={[centerTextPlugin, drawCircles]} className={styles.doughnut} />
									<div className={styles.customLegend}>
										{rawDoughnutData.map((item, index) => (
											<div key={index} className={styles.label}>
	                    <span
		                    className={styles.labelDot}
		                    style={{ backgroundColor: item.color }}
	                    />
												<div className='flex flex-column'>
		                    <span className={styles.labelTitle}>
                          {item.label}
												</span>
													<span className={styles.labelValue}>
                          {item.value}%
												</span>
												</div>
											</div>
										))}
									</div>
								</>
							) : (
								<ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
							)}
						</div>
					</Card>
					<Card title="Total Cost" className={styles.card}>
						<p className={styles.cost}>
							${stationsTotalCost}
						</p>
					</Card>
					<Card title="Average Cost" className={styles.card}>
						<p className={styles.cost}>
							${stationsAvgCost}
						</p>
					</Card>
				</div>
			</div>
			
			<div className={styles.costsBlock}>
				<div className="flex justify-content-between">
					<h3>Stations Cost</h3>
					<Button
						size="small"
						icon='pi pi-download'
						label='EXPORT TO CSV'
						text
						className={styles.downloadBtn}
					/>
				</div>
				
				{isStationsStatisticSuccess ? (
					<DataTable value={stationsStatistic} showGridlines className={styles.table}>
						<Column
							field="station"
							header="Station Name"
							body={(rowData) => {
								return <div className={styles.cellName}>{rowData.station}</div>;
							}}
						/>
						<Column
							field="total_orders"
							header="Total Orders"
							body={(rowData) => {
								return <div className={styles.cellOrders}>{rowData.total_orders}</div>;
							}}
						/>
						<Column
							field="total_cost"
							header="Total Cost"
							body={(rowData) => {
								return <div className={styles.cellCost}>{formatCurrency(rowData.total_cost)}</div>
							}}
						/>
						<Column
							field="avg_cost_per_order"
							header="Avg Cost Per Order"
							body={(rowData)=> {
								return <div className={styles.cellAvg}>{formatCurrency(rowData.avg_cost_per_order)}</div>
							}}
						/>
					</DataTable>
				) : (
					<ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
				)}
			</div>
		</>
	)
}

export default StationsStatistics